import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './FoldNavItem.module.scss';
import NavItem from './NavItem';
import Clickable from '../Clickable';

type Sub = {
  name: string;
  path: string;
}

type Props = {
  icon: string;
  label: string;
  sub: Sub[];
}

const FoldNavItem: React.FC<Props> = ({ icon, label, sub }) => {
  const [unfold, setUnfold] = useState<boolean>(false);
  const { pathname } = useLocation();

  const handleClick = () => {
    setUnfold(!unfold);
  };

  return (
    <div>
      <Clickable event={handleClick} label="unfold" inline={false} cursor={false}>
        <NavItem icon={icon} label={label} active={unfold}>
          <i className={`iconfont iconjiantou-xia ${styles.fold} ${unfold ? styles.unfold : ''}`} />
        </NavItem>
      </Clickable>
      {
        unfold && (
          sub.map((item) => (
            <Link key={item.path} to={item.path}>
              <div className={`${styles.sub} ${pathname === item.path ? styles.active : ''}`}>{item.name}</div>
            </Link>
          ))
        )
      }
    </div>
  );
};

export default FoldNavItem;
